import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { inputCls } from "@/pages/Login";

export function PasswordInput({ testId, ...p }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input data-testid={testId} type={show ? "text" : "password"} className={inputCls + " pr-11"} {...p} />
      <button type="button" data-testid={`${testId}-toggle`} onClick={() => setShow(!show)} aria-label={show ? "Nascondi password" : "Mostra password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700">{show ? <EyeOff size={18} /> : <Eye size={18} />}</button>
    </div>
  );
}
